/**
 * Game constants
 */

export const CurrentRoomGuid = "00000000-0000-0000-0000-000000000001";
export const VoidRoomGuid = "00000000-0000-0000-0000-000000000002";
export const SelfObjectGuid = "00000000-0000-0000-0000-000000000004";

/**
 * Engine logging flag - set to true to enable engine/system logging
 * This is separate from game debug mode and is intended for engine development
 */
export const ENGINE_LOGGING_ENABLED = false;

// Make available globally for legacy code
declare global {
    var CurrentRoomGuid: string;
    var VoidRoomGuid: string;
    var SelfObjectGuid: string;
}

(window as any).CurrentRoomGuid = CurrentRoomGuid;
(window as any).VoidRoomGuid = VoidRoomGuid;
(window as any).SelfObjectGuid = SelfObjectGuid;
